import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import type { LoaderProps } from '../Loader';
import Loader from '../Loader';
import styles from './LoaderOverlay.scss';

interface LoaderOverlayProps extends LoaderProps {
  backdropClassName?: string;
}

const LoaderOverlay: FC<React.PropsWithChildren<LoaderOverlayProps>> = (
  props,
) => (
  <div className={classNames(styles.container, props.backdropClassName)}>
    <Loader {...props} />
  </div>
);

export default LoaderOverlay;
